
@if (field()) {
  <div class="satisfaction-field__container">
    @if( field().title ) {
      <h2 class="ci-heading-h6-semibold">
        {{ field().title }}
      </h2>
    }
    
    @if( field().description ) {
      <p class="satisfaction-field__description ci-caption-regular">
        {{ field().description }}
      </p>
    }
    
    <div class="satisfaction-field__options-wrapper">
      @if(satisfactionLevelOptionList() && satisfactionLevelOptionList().length > 0) {
        <ul class="satisfaction-field__options">
          @for(option of satisfactionLevelOptionList(); track option.value) {
            <li class="satisfaction-field__option">
              <ci-icon-button 
                class="option__icon"
                type="standard" 
                [attr.name]="option.iconName"
                scale="2x"
                [attr.aria-label]="('Satisfacción nivel' | translate) + ' ' + option.value"
                [active]="isOptionSelected(option.value)"
                (click)="handleSelectOption(option.value)"
              ></ci-icon-button>
            </li>
          }
        </ul>
      }
    
      @if(field().required) {
        @if(showErrorMessage()) {
          <span class="satisfaction-field__error-text ci-caption-regular">
            {{ 'Por favor, seleccione una opción' | translate }}
          </span>
        } @else {
          <span class="satisfaction-field__supporting-text ci-caption-regular">
            {{ 'Obligatorio' | translate }}
          </span>
        }
      }
    </div>
  </div>
}
